import { Navigate } from 'react-router-dom';

export const HomeRoute: React.FC = () => <Navigate to="/sessions" replace />;
